import React from "react";
import "./Admission2025.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ADMISSION_APPLY } from "../../Utils/apiConst";
import Swal from "sweetalert2";
import ReCAPTCHA from "react-google-recaptcha";

function Admissions2025() {
  const [captchaValue, setCaptchaValue] = useState(null);


 
  const logos = [
    "/assets/accreditation/1.png",
    "/assets/accreditation/2.png",
    "/assets/accreditation/3.png",
    "/assets/accreditation/4.png",
    "/assets/accreditation/5.png",
    "/assets/accreditation/6.png",
    "/assets/accreditation/7.png",
    "/assets/accreditation/8.png",
    "/assets/accreditation/9.png",
    "/assets/accreditation/10.png",
    "/assets/accreditation/11.png",
    "/assets/accreditation/12.png",
    "/assets/accreditation/13.png",

    // Add more logo paths here
  ];
  const options = {
    loop: true,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 4,
      },
      1000: {
        items: 6,
      },
    },
  };
  const [loading, setLoading] = useState(0);
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [course, setCourse] = useState();

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent actual form submission
   
    if (!captchaValue) {
      alert("Please verify the captcha");
      return;
    }

    // continue with form submission
    alert("Captcha Verified, form submitted");

    if (!name || !phone || !email || !course) {
      toast.error("Please Enter all the required Details");
      return;
    }

    setLoading(1);
    const config = {
      method: "post",
      url: ADMISSION_APPLY,
      headers: {
        "Content-Type": "application/json",
        //'Authorization': `Bearer ${sessionStorage.getItem('INFO_UPLOADING_AUTH')}`
      },
      data: {
        name: name,
        phone: phone,
        email: email,
        course: course,
      },
    };

    axios(config)
      .then((res) => {
        console.log(res);
        toast.success("Succesfully Uploaded Details");
        // clearData();
        // Show Swal popup
        Swal.fire({
          title: "Application Sent successfully!",
          text: "",
          icon: "success",
          confirmButtonText: "OK",
        });
      })
      .catch((err) => {
        console.log(err);
      });

    setLoading(0);
  };

  return (
    <>
      <section className="hero_sec">
        <div className="hero-overlay" />
        <div className="container">
          <div className="row align-items-center slider-container">
            <div className="col-md-7 col-lg-7 col-12 text-center text-md-start ">
              <h1
                className="text-light text-center "
                style={{ opacity: 1, transform: "translate(0px, 0px)" }}
              >
                Excellence in Education, Enlightenment for Every Mind
              </h1>
              <div className="category-buttons text-center">
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  Engineering
                </span>
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  Science
                </span>
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  Commerce &amp; Management
                </span>
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  Arts
                </span>
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  Law
                </span>
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  IT &amp; Computer Science
                </span>
                <span style={{ opacity: 1, transform: "translate(0px, 0px)" }}>
                  Pharmacy
                </span>
              </div>
            </div>
            <div className="col-md-5 col-lg-5 col-12" id="apply-form">
              <div
                className=" card card-body"
                style={{ opacity: 1, transform: "translate(0px, 0px)" }}
              >
                <h4 className="text-center form_h">
                  Share your details and we will get in touch with you.
                </h4>
                <form
                  method="post"
                  id="myForm"
                  action=""
                  className="form needs-validation"
                  noValidate=""
                >
                  <div className="col-12 mb-2">
                    <label className="form-label">
                      Full Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter Name"
                      required=""
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                    <div className="invalid-feedback">Please Enter Name.</div>
                  </div>
                  <div className="col-12 mb-2">
                    <label className="form-label">
                      Phone <span>*</span>
                    </label>
                    <input
                      type="tel"
                      name="mobile"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                      placeholder="Enter your phone number"
                      className="form-control"
                      required=""
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);
                      }}
                    />
                    <div className="invalid-feedback">Please Enter Mobile.</div>
                  </div>
                  <div className="col-12 mb-2">
                    <label className="form-label">
                      Email <span>*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your Email ID"
                      className="form-control"
                      required=""
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    <div className="invalid-feedback">Please Enter Email.</div>
                  </div>
                  <div className="col-12 mb-2">
                    <label className="form-label">
                      Course <span>*</span>
                    </label>
                    <select
                      className="form-select"
                      required=""
                      name="course"
                      value={course}
                      onChange={(e) => {
                        setCourse(e.target.value);
                      }}
                    >
                      <option value="">Select Course</option>
                      <option value="Engineering">Engineering</option>
                      <option value="Science">Science</option>
                      <option value="Commerce & Management">
                        Commerce &amp; Management
                      </option>
                      <option value="Arts">Arts</option>
                      <option value="Law">Law</option>
                      <option value="IT & Computer Science">
                        IT &amp; Computer Science
                      </option>
                      <option value="Pharmacy">Pharmacy</option>
                    </select>
                    <div className="invalid-feedback">
                      Please Select Course.
                    </div>
                  </div>
                  <div className="col-12 mb-2">
                  <div style={{ margin: "15px 0" }}>
        <ReCAPTCHA
          sitekey="6Leu5OAqAAAAALrmeTh2EKP5WgaUgxVXUyHBhIUb"
          onChange={handleCaptchaChange}
        />
      </div>
                    
                  </div>
                  <button
                    type="submit"
                    id="ebn"
                    className="btn btn-danger w-100"
                    onClick={handleSubmit}
                  >
                    Apply Now
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="acd_sec ">
        <div className="container">
          <h2 className="acd_tl text-center pt-4 mb-4 ">
            Accreditation and Recognition
          </h2>
          <div className="row">
            <div className="col-12">
              <OwlCarousel className="owl-theme" {...options}>
                {logos.map((logo, index) => (
                  <div className="item" key={index}>
                    <img
                      src={logo}
                      alt={`Client ${index}`}
                      style={{
                        height: "200px", // Increased from 60px
                        width: "auto",
                        objectFit: "contain",
                        padding: "10px",
                      }}
                    />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>

      <section className="admisssion-area">
        <div className="container admission-content ">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div class="admission-image">
                <img
                  src="https://s3.ap-south-1.amazonaws.com/document.swaminarayanuniversity.ac.in/university-assets/facilities/infra_one.jpeg"
                  alt="Image"
                />
                <div class="icon">
                  <a
                    class="popup-youtube play-btn"
                    href="https://www.youtube.com/embed/Rywy-TJXabA?autoplay=1"
                  >
                    <i class="ri-play-fill"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <h2 className="abt_til mb-4 text-center">
                <span className="">About Us</span>
              </h2>
              <p className="text-justify">
                Established in 2022 under the Gujarat Private Universities Act,
                Swaminarayan University stands as a beacon of holistic
                education, seamlessly integrating academic excellence with
                spiritual enrichment. Nestled within a lush 100+ acre campus in
                Kalol, Gujarat, our university offers a serene environment
                conducive to learning and personal growth. <br /> <br />
                Guided by the principles of Swaminarayan Sampradaya, our mission
                is to cultivate well-rounded individuals who excel academically
                and uphold strong ethical values. We are committed to fostering
                a community where students develop critical thinking, leadership
                skills, and a sense of social responsibility.
                <br /> <br />
                Beyond academics, we emphasize the importance of extracurricular
                activities, spiritual growth, and community service. Our
                students engage in various cultural, sports, and social
                initiatives, fostering a well-rounded personality and a deep
                sense of empathy towards society.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="counters">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 counter-box">
              <i class="fa fa-tree" aria-hidden="true"></i>
              <h2 className="counter" data-target={60} data-symbol="+">
                60+
              </h2>
              <p>Acres of Lush Green Campus</p>
            </div>
            <div className="col-md-3 col-6 counter-box">
              <i class="fa fa-graduation-cap" aria-hidden="true"></i>
              <h2 className="counter" data-target={35} data-symbol="+">
                35+
              </h2>
              <p>Years of Experience</p>
            </div>
            <div className="col-md-3 col-6 counter-box">
              <i class="fa fa-building" aria-hidden="true"></i>
              <h2 className="counter" data-target={300} data-symbol="+">
                300+
              </h2>
              <p>Companies</p>
            </div>
            <div className="col-md-3 col-6 counter-box">
              <i class="fa fa-briefcase" aria-hidden="true"></i>
              <h2 className="counter" data-target={24} data-symbol="LPA">
                24LPA
              </h2>
              <p>Job Package</p>
            </div>
          </div>
        </div>
      </section>

      <section className="faculty-section mt-5 mb-5">
        <div className="container">
          <h2 className="section-title fs_til text-center mb-4">
            Choose Your Faculty
          </h2>
          <ul
            className="nav nav-tabs justify-content-center mb-5"
            id="facultyTabs"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                data-bs-toggle="tab"
                href="#engineering"
                aria-selected="true"
                role="tab"
              >
                Engineering
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#management"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                Management
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#commerce"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                Commerce
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#science"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                Science
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#law"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                Law
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#arts"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                Arts
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#it"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                IT
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#computer-science"
                aria-selected="false"
                tabIndex={-1}
                role="tab"
              >
                Computer Science
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="engineering"
              role="tabpanel"
            >
              {/* <h3>Engineering</h3> */}
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6">
                  <div className="card card-body choose border-0 shadow">
                    <h4>BE</h4>
                    <p>
                      Every great invention begins with a learner like you!
                      Unlock your potential in engineering and make a difference
                      in the world.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6">
                  <div className="card card-body choose border-0 shadow">
                    <h4>ME</h4>
                    <p>
                      Every great invention begins with a learner like you!
                      Unlock your potential in engineering and make a difference
                      in the world.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Every great invention begins with a learner like you!
                      Unlock your potential in engineering and make a difference
                      in the world.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* Other Faculties */}
            <div className="tab-pane fade" id="management" role="tabpanel">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>BBA (Hons.) (Professional Courses)</h4>
                    <p>
                      Shape your career in business or the corporate world.
                      Develop leadership, strategy, and management skills.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>MBA</h4>
                    <p>
                      Shape your career in business or the corporate world.
                      Develop leadership, strategy, and management skills.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Shape your career in business or the corporate world.
                      Develop leadership, strategy, and management skills.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="commerce" role="tabpanel">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>B.Com (Hons.) (Professional Courses)</h4>
                    <p>
                      Gain the skills to understand markets and drive impactful
                      business strategies with strong analytical acumen.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>M.Com</h4>
                    <p>
                      Gain the skills to understand markets and drive impactful
                      business strategies with strong analytical acumen.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Gain the skills to understand markets and drive impactful
                      business strategies with strong analytical acumen.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="science" role="tabpanel">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>B.Sc. (Hons.)</h4>
                    <p>
                      Turn curiosity into discoveries and knowledge into
                      innovations, and be a part of the change.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>M.Sc.</h4>
                    <p>
                      Turn curiosity into discoveries and knowledge into
                      innovations, and be a part of the change.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Turn curiosity into discoveries and knowledge into
                      innovations, and be a part of the change.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="law" role="tabpanel">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>LL.B</h4>
                    <p>
                      Justice begins with those who dare to stand for it. Embark
                      on a career in law.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>LL.M</h4>
                    <p>
                      Justice begins with those who dare to stand for it. Embark
                      on a career in law.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Justice begins with those who dare to stand for it. Embark
                      on a career in law.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="arts" role="tabpanel">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>B.A (Hons.)</h4>
                    <p>
                      Explore the beauty of expressions, literature, and human
                      understanding. Begin your transformative journey in Arts.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>M.A.</h4>
                    <p>
                      Explore the beauty of expressions, literature, and human
                      understanding. Begin your transformative journey in Arts.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Explore the beauty of expressions, literature, and human
                      understanding. Begin your transformative journey in Arts.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="it" role="tabpanel">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>B.Sc. IT (Hons.) (Professional Courses)</h4>
                    <p>
                      Be a part of the world that needs problem-solvers and
                      tech-enthusiasts. Begin your journey toward endless
                      opportunities and innovation.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>M.Sc.IT</h4>
                    <p>
                      Be a part of the world that needs problem-solvers and
                      tech-enthusiasts. Begin your journey toward endless
                      opportunities and innovation.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Be a part of the world that needs problem-solvers and
                      tech-enthusiasts. Begin your journey toward endless
                      opportunities and innovation.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="computer-science"
              role="tabpanel"
            >
              <div className="row">
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>BCA (Hons.)</h4>
                    <p>
                      Pursue your passion for technology, shape your future in
                      computer science, and lead the digital revolution.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 ">
                  <div className="card card-body choose border-0 shadow">
                    <h4>MCA</h4>
                    <p>
                      Pursue your passion for technology, shape your future in
                      computer science, and lead the digital revolution.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-6 smt-2">
                  <div className="card card-body choose border-0 shadow">
                    <h4>Ph.D</h4>
                    <p>
                      Pursue your passion for technology, shape your future in
                      computer science, and lead the digital revolution.
                    </p>
                    {/* <button class="btn btn-danger">Apply Now</button> */}
                    <a href="#apply-form" className="btn btn-danger">
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="graduates-work-section py-5">
        <div className="container text-center">
          <h2 className="gr-title">Where our graduates work</h2>
          <p className="mb-4">Top companies trust us to deliver top talent.</p>
          <div className="d-flex justify-content-around align-items-center flex-wrap">
            <div className="company_logo">
              {" "}
              <img
                src="/assets/accreditation/capgemeni.png"
                alt="TCS LOGO"
                className="img-fluid bg-logo"
                srcset=""
              />
            </div>
            <div className="company_logo">
              {" "}
              <img
                src="/assets/accreditation/cognizant.png"
                alt="TCS LOGO"
                className="img-fluid bg-logo"
                srcset=""
              />
            </div>
            <div className="company_logo">
              {" "}
              <img
                src="/assets/accreditation/ericsson.png"
                alt="TCS LOGO"
                className="img-fluid bg-logo"
                srcset=""
              />
            </div>
            <div className="company_logo">
              {" "}
              <img
                src="/assets/accreditation/tcs.png"
                alt="TCS LOGO"
                className="img-fluid bg-logo"
                srcset=""
              />
            </div>
            <div className="company_logo">
              {" "}
              <img
                src="/assets/accreditation/microsoft.png"
                alt="TCS LOGO"
                className="img-fluid bg-logo"
                srcset=""
              />
            </div>
          </div>
        </div>
      </section>

      <section className="offerings-section mt-3">
        <div className="container">
          <h2 className="offerings-title text-center">
            Our Holistic Offerings
          </h2>{" "}
          <br />
          <div className="row">
            <div className="col-sm-4">
              <div className="card card-body choose border-0 shadow">
                <i className="fa fa-briefcase mb-2 fa-2x text-primary" />
                <h4>Training and Placement</h4>
                <p>
                  Bridging academics and industry with expert guidance,
                  internships, and career opportunities.
                </p>
              </div>
            </div>
            <div className="col-sm-4">
              {" "}
              <div className="card card-body choose border-0 shadow">
                <i className="fa fa-bus mb-2 fa-2x text-primary" />
                <h4>Transport Facility</h4>
                <p>
                  Safe, reliable, and well-connected transportation for
                  hassle-free commuting.
                </p>
              </div>
            </div>
            <div className="col-sm-4">
              {" "}
              <div className="card card-body choose border-0 shadow">
                <i class="ri-artboard-fill mb-2 fa-2x text-primary"></i>
                <h4>Digital Classroom</h4>
                <p>
                  Interactive, tech-enabled learning spaces with smartboards and
                  multimedia tools.
                </p>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card card-body choose border-0 shadow">
                <i className="fa fa-bed mb-2 fa-2x text-primary" />
                <h4>Hostel Facility</h4>
                <p>
                  Comfortable, secure accommodations fostering a homely and
                  disciplined environment.
                </p>
              </div>
            </div>
            <div className="col-sm-4">
              {" "}
              <div className="card card-body choose border-0 shadow">
                <i class="fa-solid fa-dumbbell mb-2 fa-2x text-primary"></i>
                <h4>Gym</h4>
                <p>
                  State-of-the-art fitness center promoting health and an active
                  lifestyle.
                </p>
              </div>
            </div>
            <div className="col-sm-4">
              {" "}
              <div className="card card-body choose border-0 shadow">
                <i className="fa fa-book mb-2 fa-2x text-primary" />
                <h4>Library &amp; Labs</h4>
                <p>
                  Extensive resources and cutting-edge labs for hands-on
                  learning and research excellence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-section py-5">
        <div className="container">
          <h2 className="text-center mb-4 faq_h">FAQs</h2>
          <div className="accordion" id="faqAccordion">
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  What is Swaminarayan University known for?
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#faqAccordion"
                style={{}}
              >
                <div className="accordion-body">
                  Swaminarayan University is known for its holistic education
                  approach, integrating academic excellence with spiritual and
                  ethical values. It offers a wide range of programs in
                  Engineering, Management, Sciences, Pharmacy, Law, and more.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  When was Swaminarayan University established?
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Swaminarayan University was established in 2022 under the
                  Gujarat Private Universities Act.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Is Swaminarayan University recognized by government bodies?
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes, the university is accredited and recognized by UGC,
                  AICTE, BCI, PCI, INC, and other esteemed regulatory bodies.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  What programs and courses does Swaminarayan University offer?
                </button>
              </h2>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  The university offers undergraduate, postgraduate, diploma,
                  certificate, and doctoral programs in disciplines such as
                  Engineering, Management, Sciences, Pharmacy, Law, Computer
                  Applications, Arts, Design, and Education.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingFive">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="true"
                  aria-controls="collapseFive"
                >
                  Where is Swaminarayan University located?
                </button>
              </h2>
              <div
                id="collapseFive"
                className="accordion-collapse collapse show"
                aria-labelledby="headingFive"
                data-bs-parent="#faqAccordion"
                style={{}}
              >
                <div className="accordion-body">
                  The university is situated in Kalol, Gujarat, on the
                  Ahmedabad-Mehsana Highway at Shree Swaminarayan Vishvamangal
                  Gurukul.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingSix">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  What kind of facilities are available on campus?
                </button>
              </h2>
              <div
                id="collapseSix"
                className="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Swaminarayan University provides modern classrooms,
                  well-equipped laboratories, extensive libraries, comfortable
                  residential facilities, and advanced research centers.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingSeven">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="false"
                  aria-controls="collapseSeven"
                >
                  Does the university offer placement opportunities?
                </button>
              </h2>
              <div
                id="collapseSeven"
                className="accordion-collapse collapse"
                aria-labelledby="headingSeven"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes, Swaminarayan University has strong industry connections
                  with top recruiters ensuring excellent placement opportunities
                  for students.
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 shadow-sm">
              <h2 className="accordion-header" id="headingEight">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEight"
                  aria-expanded="false"
                  aria-controls="collapseEight"
                >
                  How can I contact the university for further inquiries?
                </button>
              </h2>
              <div
                id="collapseEight"
                className="accordion-collapse collapse"
                aria-labelledby="headingEight"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  You can reach Swaminarayan University at:
                  <br />
                  📍 Ahmedabad-Mehsana Highway, Kalol, Gujarat, India
                  <br />
                  📞 Phone: +91-6357 675 561/2/3
                  <br />
                  📧 Email: info@swaminarayanuniversity.ac.in
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer>
  <div className="container mt-4">
    <div className="row">
     <div className="col-sm-8">
     <img
                      src="/assets/images/logo.png"
                      className="main-logo"
                      lt="logo" width={400}
                    /> <br />
                    <p className="mt-3">Shree Swaminarayan Vishvamangal Gurukul, Ahmedabad-Mehsana Highway, At & Po-Saij, Tal-Kalol,Dist. Gandhinagar - 382725, Gujarat</p>
     </div>
     <div className="col-sm-4">
     <div className="contact">
      <h4>Contact</h4>
      <br />
  <a href="tel:+91 63576 75561"  className=" text-dark">
  <h5><i class="ri-phone-fill me-3"></i>+91 63576 75561/2/3{" "}</h5>
  </a>

  <a href="tel:+91 1800 203 7800" className=" text-dark">
 <h5> <i class="ri-customer-service-2-fill me-3"></i> Toll Free 1800 203 7800</h5>
  </a>
  <a href="mailto:info@swaminarayanuniversity.ac.in" className=" text-dark">
 <h5> <i class="ri-mail-send-fill me-3"></i> info@swaminarayanuniversity.ac.in</h5>
  </a>
</div>
     </div>
    </div>
  </div>
</footer>

    </>
  );
}

export default Admissions2025;
